// format data for details

const displayNamesText = {
  id: "Id",
  text_uri: "Text URI",
  title_ar: "Title (Arabic)",
  title_lat: "Title (Transcription)",
  text_type: "Text Type",
  tags: "Tags",
  related_persons: "Related Persons",
};

const displayNamesVersion = {
  id: "Id",
  version_id: "Version Id",
  version_uri: "Version URI",
  char_length: "Length(Char)",
  tok_length: "Length(Words)",
  url: "Text URL",
  editor: "Editor",
  version_lang: "Version Language",
  tags: "Tags",
  notes: "Notes",
  analysis_priority: "Analysis Priority",
  annotation_status: "Annotation Status",
};
const displayNamesAuthor = {
  id: "Id",
  author_uri: "Author URI",
  author_ar: "Author (Arabic)",
  author_lat: "Author (Transcription)",
  authorDateAH: "Death Date (AH)",
  authorDateCE: "Death Date (CE)",
  authorDateString: "Date (String)",
  notes: "Notes",
  name_elements: "Name Elements",
  related_persons: "Related Persons",
  related_places: "Related Places",
};

const displayAuthorDetailsRelatedPlaces = {
  relation_type_code: "Relation Type Code",
  relation_subtype_code: "Relation Subtype Code",
  start_date_AH: "Start Date (AH)",
  end_date_AH: "End Date (AH)",
  authority: "Authority",
  confidence: "Confidence",
  related_place_uri: "Related Place URI",
  relation_type_name: "Relation Type Name",
};

export {
  displayNamesAuthor,
  displayNamesText,
  displayNamesVersion,
  displayAuthorDetailsRelatedPlaces,
};
